import React from 'react';
import styled from 'styled-components';

import Page from 'components/Page';
import removeImgSrcset from 'utilities/removeImgSrcset';


const SingleColumnTemplate = ({ page: { acf: { content, background_color } } }) => {
    return (
        <Page>
            <Outer $backgroundColor={background_color}>
                <Inner>
                    <Content className="content" dangerouslySetInnerHTML={{ __html: removeImgSrcset(content) }} />
                </Inner>
            </Outer>
        </Page>
    );
};


export default SingleColumnTemplate;


const Outer = styled.div`
    width: 100%;
    height: 100%;
    padding: 4rem;
    background-color: ${props => props.$backgroundColor};
`;

const Inner = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    border: .3rem solid;
    border-image-source: ${props => props.theme.gold_gradient};
    border-image-slice: 1;
    padding: 4rem;
`;

const Content = styled.div`
    text-align: center;
    max-width: 90rem;
`;
